/* istanbul ignore file */
import qs from 'qs';
import { useInfiniteQuery } from '@tanstack/react-query';

const ENDPOINT = '/ajax/users/available-users';
const RANGE = 20;

const useAvailableUsers = (search, { shouldFetchOnMount, ...queryParams }) =>
  useInfiniteQuery({
    queryKey: ['available-users', search, queryParams],
    initialPageParam: 0,
    queryFn: async ({ pageParam }) => {
      const headers = new Headers();
      headers.append('X-Requested-With', 'XMLHttpRequest');
      headers.append('range', `items=${pageParam}-${Number(pageParam) + RANGE - 1}`);

      const options = {
        method: 'GET',
        headers,
      };

      const { isMentorOnly, organizationId, excludeIds, ...otherQueryParams } = queryParams;

      const parameters = {
        q: search,
        ...otherQueryParams,
      };

      if (isMentorOnly) {
        parameters.mentor = true;
      }

      if (organizationId) {
        parameters.organization = organizationId;
      }

      if (excludeIds) {
        parameters.user_id_not_in = excludeIds;
      }

      const parametersStringified = qs.stringify(parameters);

      // FIXME: use api when available
      const response = await fetch(`${ENDPOINT}?${parametersStringified}`, options);
      const jsonResponses = await response.json();

      let rangeEnd;
      let total;
      const contentRange = response.headers.get('Content-Range');

      if (contentRange) {
        // rangeEnd regexp: 20-39/65 -> 39
        rangeEnd = Number(contentRange.replace(/.*-(.*)\/.*/, '$1'));
        // total regexp: 20-39/65 -> 65
        total = Number(contentRange.replace(/.*\/(.*)/, '$1'));
      } else {
        total = jsonResponses.length;
        rangeEnd = total;
      }

      return { rangeEnd, total, users: jsonResponses };
    },
    getNextPageParam: ({ rangeEnd, total }) => (rangeEnd + 1 >= total ? false : rangeEnd + 1),
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: Boolean(shouldFetchOnMount || search),
  });

// eslint-disable-next-line import/prefer-default-export
export { useAvailableUsers };
